class MenuDrawerSubmenu extends HTMLElement {
  constructor() {
    super();
    this.openButtonElement = this.querySelector('[data-submenu-open]');
    this.closeButtonElement = this.querySelector('[data-submenu-close]');
    this.openSubmenu = this.openSubmenu.bind(this);
    this.closeSubmenu = this.closeSubmenu.bind(this);
  }

  connectedCallback() {
    this.openButtonElement.addEventListener('click', this.openSubmenu);
    this.closeButtonElement.addEventListener('click', this.closeSubmenu);
  }

  disconnectedCallback() {
    this.openButtonElement.removeEventListener('click', this.openSubmenu);
    this.closeButtonElement.removeEventListener('click', this.closeSubmenu);
  }

  openSubmenu() {
    this.classList.add('menu-drawer__submenu--open');
    this.openButtonElement.setAttribute('aria-expanded', 'true');
  }

  closeSubmenu() {
    this.classList.remove('menu-drawer__submenu--open');
    this.openButtonElement.setAttribute('aria-expanded', 'false');
  }
}

class MenuDrawer extends HTMLElement {
  connectedCallback() {
    const drawerContainerElement = document.querySelector(this.dataset.drawerContainer);
    if (!drawerContainerElement || this.parentElement === drawerContainerElement) return;
    drawerContainerElement.append(this);
    this.hidden = false;
  }
}

if (!customElements.get('menu-drawer')) {
  customElements.define('menu-drawer', MenuDrawer);
}

if (!customElements.get('menu-drawer-submenu')) {
  customElements.define('menu-drawer-submenu', MenuDrawerSubmenu);
}
